// An invitation opened from its email, kept until it is accepted or dropped. localStorage,
// not sessionStorage: signing up can continue in another tab, from the verification email.

const KEY = "pending-invitation";

export function getPendingInvitation() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || "null");
    return saved && typeof saved.token === "string" ? saved : null;
  } catch {
    return null;
  }
}

export function setPendingInvitation(invitation) {
  try {
    localStorage.setItem(KEY, JSON.stringify(invitation));
  } catch {
    // no storage: the person opens the link again after signing up
  }
}

export function clearPendingInvitation() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // nothing was kept
  }
}
